import Typography from '@hellodarwin/core/lib/components/common/typography';
import { media } from '@hellodarwin/core/lib/theme/mixins/responsive';
import styled from 'styled-components';
export const FileBoxContainer = styled.div `
  position: relative;
  display: flex;
  flex-direction: row;
  border: 1px solid ${({ theme }) => theme.colors.grey_1};
  background-color: ${({ theme }) => theme.colors.beige_2};
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;
export const DownloadIconContainer = styled.div `
  position: static;
  padding: 8px;
  cursor: pointer;
  z-index: 2;

  ${media.xl `
    position: absolute;
    top: 0px;
    right: 0px;
  `}
`;
export const FileBoxContentContainer = styled.div `
  display: flex;
  flex-direction: row;
  gap: 16px;
  padding: 12px 8px 12px 16px;

  ${media.xl `
    flex-direction: column;
    gap: 6px;
    align-items: center;
    padding: 12px 8px;
  `}
`;
export const FileBoxTitle = styled(Typography) `
  ${media.xl `
    text-align: center;
  `}
`;
export const FileIconContainer = styled.div `
  width: fit-content;
  height: fit-content;
  padding: 6px;
  border-radius: 4px;
  background-color: ${({ theme }) => theme.colors.grey_1};
  line-height: 0;
`;
export const FileBoxDetailsContainer = styled.div `
  display: flex;
  flex-direction: row;
  gap: 8px;

  ${media.xl `
    align-items: center;
  `}
`;
export const FileBoxDetail = styled(Typography) `
  ${media.xl `
    text-align: center;
    width: 50%;
  `}
`;
export const FileBoxContentHeader = styled.div `
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.xs}px;
`;
